import React, { useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { updateMetaTags } from '@/utils/seoCore';
import { generateHreflangLinks, updateHreflangLinks } from '@/lib/swissHreflang';
import { generateOrganizationSchema, injectSchema } from '@/lib/swissSchema';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import WebsiteCostCalculator from '@/components/WebsiteCostCalculator';

const CalculatorPage = () => {
  const { currentLanguage } = useLanguage();

  useEffect(() => {
    // SEO meta tags for calculator page
    updateMetaTags({
      title: 'Website Kosten Rechner Schweiz - Transparente Preise | Future Level',
      description: 'Kostenloses Tool: Berechnen Sie Website-Kosten in der Schweiz. Transparent, fair, CHF-Preise. Für KMU, E-Commerce, mehrsprachige Websites.',
      canonicalUrl: `https://www.future-level.ch/${currentLanguage}/website-kosten-rechner`,
      language: currentLanguage,
      keywords: 'Website Kosten, Webdesign Preise Schweiz, Website Rechner, CHF Kosten, Webdesign Kalkulator'
    });

    // Hreflang for calculator
    const hreflangLinks = generateHreflangLinks({
      currentLanguage: currentLanguage as any,
      currentPath: '/website-kosten-rechner',
      availableLanguages: ['de', 'fr', 'it', 'en']
    });
    updateHreflangLinks(hreflangLinks);

    // Organization schema
    const orgSchema = generateOrganizationSchema({ language: currentLanguage as any });
    
    // Calculator-specific schema
    const calculatorSchema = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Website Kosten Rechner Schweiz",
      "description": "Kostenloses Tool zur Berechnung von Website-Kosten in der Schweiz",
      "url": `https://www.future-level.ch/${currentLanguage}/website-kosten-rechner`,
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web Browser",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "CHF",
        "description": "Kostenlose Website-Kostenberechnung"
      },
      "provider": {
        "@type": "Organization",
        "name": "Future Level",
        "url": "https://www.future-level.ch"
      }
    };

    injectSchema({
      "@context": "https://schema.org",
      "@graph": [orgSchema, calculatorSchema]
    });
  }, [currentLanguage]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-blue-950 to-slate-900">
      <Header />
      
      <main className="pt-20 pb-20">
        <WebsiteCostCalculator />
      </main>
      
      <Footer />
    </div>
  );
};

export default CalculatorPage;